import { Button } from '@/components/Button';
import IconClose from '@/components/CardWrapper/assets/icon_close.svg?react';
import classNames from 'classnames';
import React, { FC } from 'react';
import './index.less';

export interface ModalHeaderProps {
  title: React.ReactNode;
  onClose?: () => void;
  className?: string;
  rightContent?: React.ReactNode;
  showClose?: boolean;
}

const ModalHeader: FC<ModalHeaderProps> = ({ title, onClose, className, rightContent, showClose = true }) => {
  return (
    <div className={classNames('syn-modal-header-common', className)}>
      <div className="syn-modal-header-common-title">{title}</div>
      <div className="syn-modal-header-common-right">
        {rightContent}
        {showClose && onClose && (
          <Button
            className="syn-modal-header-common-close"
            type="text"
            icon={<IconClose className="syn-icon" />}
            onClick={onClose}
            size="small"
          />
        )}
      </div>
    </div>
  );
};

export default ModalHeader;
